const INTCMP_TEMPLATE_TEXT = 'skysport_livematch_<%intcmp%>_tab';
const INTCMP_LGP_TEMPLATE_TEXT = 'skysport_sportsdata_<%intcmp%>_tab';
const INTCMP_PP_TEMPLATE_TEXT = 'skysport_playerpage_<%intcmp%>_tab';
const INTCMP_DP_TEMPLATE_TEXT = 'skysport_driverpage_<%intcmp%>_tab';

export const composeIntcmp = (tabName: string, variant?: string) => {
  switch (variant) {
    case 'LGP':
      return INTCMP_LGP_TEMPLATE_TEXT.replace('<%intcmp%>', tabName);
    case 'PP':
      return INTCMP_PP_TEMPLATE_TEXT.replace('<%intcmp%>', tabName);
    case 'DP':
      return INTCMP_DP_TEMPLATE_TEXT.replace('<%intcmp%>', tabName);
    default:
      return INTCMP_TEMPLATE_TEXT.replace('<%intcmp%>', tabName);
  }
};

export const trackIntcmp = (tabName: string, variant?: string) => {
  const intcmp = composeIntcmp(tabName, variant);
  localStorage.setItem('intcmp', intcmp);
};

/** Hydrate intcmp on  */
export const hydrateIntcmp = (element: HTMLElement) => {
  const intcmpArray = Array.from(element.querySelectorAll('[data-intcmp]'));
  intcmpArray.forEach((elm) => {
    const listener: EventListener = () => {
      const intcmpAtt = elm.getAttribute('data-intcmp');
      localStorage.setItem('intcmp', intcmpAtt || '');
    };
    elm.addEventListener('click', listener);
  });
};
